import { useState, useEffect } from "react";
import AdminCitas from "./AdminCitas";
import AdminCrearCitas from "../../components/admin/AdminCrearCitas";
import AdminAgendaCitas from "../../components/admin/AdminAgendaCitas";
import AdminDiasLaborables from "../../components/admin/AdminDiasLaborables";
import { Container } from "react-bootstrap";

const PASSWORD = "esperanto";

const EditorScreen = () => {
    const [autorizado, setAutorizado] = useState(false);

    useEffect(() => {
        const accesoPrevio = sessionStorage.getItem("editor_autorizado");
        if (accesoPrevio === "true") {
            setAutorizado(true);
        } else {
            const pass = prompt("Introduce la contraseña para acceder al editor:");
            if (pass === PASSWORD) {
                sessionStorage.setItem("editor_autorizado", "true");
                setAutorizado(true);
            } else {
                alert("Acceso denegado.");
                window.location.href = "/";
            }
        }
    }, []);

    if (!autorizado) return null;

    return (
        <Container fluid="xxxl" style={{ padding: "0 40px" }}>
            <AdminCitas />
            <AdminCrearCitas />
            <AdminDiasLaborables />
            <AdminAgendaCitas />
        </Container>
    );
};

export default EditorScreen;
